import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import moment from "moment";

export class ReservationByRatePlan extends AbstractReport {

    getCheckOut(value) {

        if (this.same_day_checkout) {

            return moment(value, 'DD/MM/YYYY').subtract(1, 'day').format('DD/MM/YYYY');
        }

        return value;
    }
}

AccessorsMutatorsDecorator(
    'ident',
    'guest_name',
    'check_in',
    'check_out',
    'room_type',
    'reservation_id',
    'guest_id',
    'same_day_checkout',
)(ReservationByRatePlan);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/production/reservation-by-rate-plan.model.js